<template>
  <div class="settings flex flex-col gap-1">
    <el-card class="dense">
      <div slot="header" class="clearfix">Mobile</div>
      <div class="clearfix" />
      <el-form size="mini" v-if="envs.mobile">
        <div class="flex flex-wrap gap-1">
          <div class="box h300 w400">
            <div class="box-title flex-space align-center">
              <div>Version & Changelog</div>
              <a @click="saveMobile">Save</a>
            </div>
            <div class="box-content">
              <el-row :gutter="10">
                <el-col :span="24">
                  <em class="gray"
                    >The reviewer from Google Play/App Store will only see
                    "Demo" tenant when we submit a new app version. If the app
                    is passed and released to production, please update the
                    exact platform version here.</em
                  >
                </el-col>
                <el-col :span="12">
                  <el-form-item label="iOS">
                    <el-input v-model="envs.mobile.ios" />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="Android">
                    <el-input v-model="envs.mobile.android" />
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="Changelog">
                    <el-input
                      v-model="envs.mobile.changelog"
                      type="textarea"
                      :autosize="{ minRows: 5 }"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="box h300 w400">
            <div class="box-title flex-space align-center">
              <div>Background Geolocation Configuration</div>
              <a @click="saveMobile">Save</a>
            </div>
            <div class="box-content">
              <el-form-item label="">
                <el-input
                  v-model="envs.mobile.bgconfig"
                  type="textarea"
                  :autosize="{ minRows: 6, maxRows: 15 }"
                />
              </el-form-item>
            </div>
          </div>
          <div class="box h300 w400">
            <div class="box-title flex-space align-center">
              <div>Genius Scan Configuration</div>
              <a @click="saveMobile">Save</a>
            </div>
            <div class="box-content">
              <el-form-item label="">
                <el-input
                  v-model="envs.mobile.gsconfig"
                  type="textarea"
                  :autosize="{ minRows: 6, maxRows: 15 }"
                />
              </el-form-item>
            </div>
          </div>
          <div class="box h300 w400">
            <div class="box-title flex-space align-center">
              <div>Jitsi Configuration</div>
              <a @click="saveMobile">Save</a>
            </div>
            <div class="box-content">
              <el-form-item label="">
                <el-input
                  v-model="envs.mobile.jitsi"
                  type="textarea"
                  :autosize="{ minRows: 6, maxRows: 15 }"
                />
              </el-form-item>
            </div>
          </div>
        </div>
      </el-form>
    </el-card>
    <el-card class="dense">
      <div slot="header" class="clearfix">Others</div>
      <div class="clearfix" />
      <el-form size="mini" v-if="envs.mobile">
        <div class="flex flex-wrap gap-1">
          <div class="box h300 w400">
            <div class="box-title flex-space align-center">
              <div>Credentials</div>
              <a @click="saveCredentials">Save</a>
            </div>
            <div class="box-content">
              <em class="gray">
                Use YAML format
                <el-popover placement="right" width="300" trigger="hover">
                  <pre>{{ yaml }}</pre>
                  <a class="el-icon-warning fs16" slot="reference" />
                </el-popover>
              </em>
              <el-form size="mini">
                <el-form-item>
                  <el-input
                    v-model="envs.credentials"
                    type="textarea"
                    :autosize="{ minRows: 6, maxRows: 15 }"
                  />
                </el-form-item>
              </el-form>
            </div>
          </div>
          <div class="box h300 w400">
            <div class="box-title flex-space align-center">
              <div>Trace Rules</div>
              <a @click="saveTraceRules">Save</a>
            </div>
            <div class="box-content">
              <em class="gray">
                Use YAML format
                <el-popover placement="right" width="300" trigger="hover">
                  <pre>{{ yaml }}</pre>
                  <a class="el-icon-warning fs16" slot="reference" />
                </el-popover>
              </em>
              <el-form size="mini">
                <el-form-item>
                  <el-input
                    v-model="envs.trace_rules"
                    type="textarea"
                    :autosize="{ minRows: 6, maxRows: 15 }"
                  />
                </el-form-item>
              </el-form>
            </div>
          </div>
          <div class="box h300 w400">
            <div class="box-title flex-space align-center">
              <div>Subscription Details</div>
              <a @click="saveSubscriptionDetails">Save</a>
            </div>
            <div class="box-content">
              <em class="gray">
                Use YAML format
                <el-popover placement="right" width="300" trigger="hover">
                  <pre>{{ yaml }}</pre>
                  <a class="el-icon-warning fs16" slot="reference" />
                </el-popover>
              </em>
              <el-form size="mini">
                <el-form-item>
                  <el-input
                    v-model="envs.subscription_details"
                    type="textarea"
                    class="yaml-input"
                    :autosize="{ minRows: 6, maxRows: 15 }"
                  />
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
      </el-form>
    </el-card>
  </div>
</template>
<script>
export default {
  name: "Settings",
  data() {
    return {
      envs: {},
      yaml: "bnsf:\n - account1\n - password1\ncn:\n - account2\n - password2",
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.$http
        .get("/system/admins/envs.json")
        .then((response) => {
          this.envs = response.data;
          this.envs.mobile ||= {};
          this.envs.credentials ||= {};
        })
        .catch((err) => {});
    },
    saveMobile() {
      this.saveEnvs({ mobile: this.envs.mobile });
    },
    saveCredentials() {
      this.saveEnvs({ credentials: this.envs.credentials });
    },
    saveTraceRules() {
      this.saveEnvs({ trace_rules: this.envs.trace_rules });
    },
    saveSubscriptionDetails() {
      this.saveEnvs({ subscription_details: this.envs.subscription_details });
    },
    saveEnvs(data) {
      this.$http
        .post("/system/admins/envs.json", { envs: data })
        .then((response) => {
          this.$message({ message: "Saved successfully", type: "success" });
        })
        .catch((err) => {});
    },
  },
};
</script>
<style scoped>
.yaml-input >>> textarea {
  font-family: monospace;
}
</style>
